@for (conta of contas; track conta.idContasReceber) {
    <div class="nfefl-item">
        <div class="nfefl-item-cabecalho">
            <mat-icon class="material-symbols-outlined nfefl-item-icone">receipt_long</mat-icon>
            <span class="nfefl-item-titulo">Título {{ conta.numeroDocumento ? '#' + conta.numeroDocumento : '' }} - {{ conta.descricaoOriginal }}</span>
            <span class="nfefl-item-valor">{{ conta.valorTotal | abnt:'preco':2 }}</span>
            @if (!isExclusao && podeVerContasReceber) {
                <a class="nfefl-link" [href]="linkTitulo(conta)" target="_blank" rel="noopener"
                    matTooltip="Abrir o título no contas a receber (nova aba)." aria-label="Abrir o título no contas a receber">
                    <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
                </a>
            }
        </div>
        <div class="nfefl-linhas">
            @for (parcela of conta.parcelas; track parcela.idContasReceberParcela) {
                <div class="nfefl-linha" [class.nfefl-bloqueada]="isExclusao && !!parcela.motivoBloqueioExclusao"
                    [class.nfefl-cancelada]="isCancelada(parcela)">
                    <span>{{ parcela.nroParcela }}/{{ conta.parcelas.length }}</span>
                    <span>{{ parcela.dataVencimento | diaCivil }}</span>
                    <span class="nfefl-valor">{{ parcela.valor | abnt:'preco':2 }}</span>
                    <span class="nfefl-situacao">{{ isExclusao ? acaoParcela(parcela) : situacaoParcela(parcela) }}</span>
                    @if (previstos(parcela); as partes) {
                        @if (partes.length) {
                            <span class="nfefl-previstos">
                                @for (p of partes; track p.rotulo) {
                                    @if (!$first) { · }{{ p.rotulo }} {{ p.valor | abnt:'preco':2 }}
                                }
                            </span>
                        }
                    }
                </div>
            }
        </div>
    </div>
}

@for (mov of movimentacoes; track mov.idMovimentacao) {
    <div class="nfefl-item" [class.nfefl-bloqueada]="isExclusao && !!mov.motivoBloqueioExclusao">
        <div class="nfefl-item-cabecalho">
            <mat-icon class="material-symbols-outlined nfefl-item-icone">{{ isTarifa(mov) ? 'payments' : 'account_balance_wallet' }}</mat-icon>
            <span class="nfefl-item-titulo">{{ isTarifa(mov) ? 'Tarifa do intermediador' : 'Movimentação' }} em {{ mov.descricaoConta }} ({{ mov.dataMovimentacao | datetimeEmpresa:'dd/MM/yyyy' }})</span>
            <span class="nfefl-item-valor">{{ mov.valor | abnt:'preco':2 }}</span>
            @if (!isExclusao && podeVerExtrato) {
                <a class="nfefl-link" [href]="linkMovimentacao(mov)" target="_blank" rel="noopener"
                    matTooltip="Abrir a movimentação no extrato (nova aba)." aria-label="Abrir a movimentação no extrato">
                    <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
                </a>
            }
        </div>
        <div class="nfefl-situacao nfefl-situacao-mov">{{ isExclusao ? acaoMovimentacao(mov) : situacaoMovimentacao(mov) }}</div>
    </div>
}
